import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { WhyChooseUs } from './components/WhyChooseUs';
import { ServicesSection } from './components/ServicesSection';
import { HowItWorks } from './components/HowItWorks';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CTABanner } from './components/CTABanner';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <WhyChooseUs data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <CTABanner data-id="element-8" />
        <ContactSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}